(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TrackController', TrackController);

    TrackController.$inject = ['GenericEntityDatatableService', 'CoreService', 'Track', 'GUIUtils', '$uibModal',
        'ConfirmationService', '$q'];

    function TrackController(GenericEntityDatatableService, CoreService, Track, GUIUtils, $uibModal,
                             ConfirmationService, $q) {

        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id
        };

        vm.descriptor = {
            title: 'Tracks',
            newButtonTitle: 'New Track',
            entityClassHumanized: 'Track',
            entityStateName: 'track',
            service: Track,
            serviceMethod: 'filter',
            params: params,
            pagination: 'remote',
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                },
                {
                    name: 'description',
                    title: 'Description',
                },
                {
                    name: null,
                    title: 'Enabled',
                    render: function (data) {
                        return GUIUtils.colorHtmlYesNo(data.enabled);
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Track',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/track/update/track-dialog.html',
                controller: 'TrackDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            description: null,
                            enabled: true,
                            id: null,
                            facility: CoreService.getCurrentFacility()
                        };
                    }],
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/track/update/track-dialog.html',
                controller: 'TrackDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['Track', function (Track) {
                        return Track.get({id: id}).$promise;
                    }],
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Track').result.then(function () {
                    Track.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();
